@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;
@use "./FilterControls.module.scss" as sidebar;

.productGrid {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    display: flex;
    gap: var(--spacer-40);
    padding-block: var(--spacer-64) var(--spacer-80);

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.grid {
    flex: 1;
    order: 1;
    display: flex;
    flex-direction: column;
    gap: var(--labui-grid-gap);
    container-type: inline-size;
}

.gridHeader {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: var(--spacer-16);
    padding-bottom: var(--spacer-16);
    border-bottom: 1px solid var(--gray-500);
}

.gridTitleWrapper {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 8px 16px;
}

.gridTitle {
    font: var(--font-h-32-forma);
}

.productCount {
    font: var(--font-button-16);
}

.sortSelect {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: var(--spacer-8);

    @media ($below-mobile) {
        display: none;
    }
}

.sortLabel {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.sortButton {
    display: flex;
    align-items: center;
    gap: var(--spacer-4);
    font: var(--font-button-16);
    white-space: nowrap;
}

.sortCaret {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    rotate: 90deg;
}

.sortPopover {
    border: 1px solid var(--gray-300);
    font: var(--font-button-16);
}

.sortListBoxItem {
    composes: outline from "../../styles/composable/utility.module.css";
    padding: var(--spacer-16) var(--spacer-8);

    &[data-selected="true"],
    &[data-focused="true"] {
        background-color: var(--gray-300);
    }

    &[data-hovered="true"] {
        background-color: var(--gray-100);
    }
}

.mobileActions {
    display: flex;

    > *:first-child {
        border-right-width: 0;
    }

    @media ($above-mobile) {
        display: none;
    }
}

.mobileActionsButton {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 40px;
    border: 1px solid var(--gray-500);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.mobileSortIcon {
    --inline-inset: var(--spacer-8);

    position: absolute;
}

.mobileFilterSvg {
    composes: mobileSortIcon;
    left: var(--inline-inset);
    width: 12px;
    height: 12px;
}

.mobileSortSvg {
    composes: mobileSortIcon;
    right: var(--inline-inset);
    width: 20px;
    height: 20px;
    rotate: 90deg;
}

.sortModal {
    position: fixed;
    inset: 0;
    z-index: 100;
    background-color: var(--white);
}

.sortModalWrapper {
    height: 100dvh;
}

.sortModalHeader {
    position: sticky;
    top: 0;
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: var(--labui-container-margin);
    border-bottom: 1px solid var(--gray-300);
}

.sortModalTitle {
    font: var(--font-nav-16);
    text-transform: uppercase;
}

.sortModalClose {
    --close-size: 40px;
    --close-icon-size: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--close-size);
    height: var(--close-size);
    translate: calc((var(--close-size) - var(--close-icon-size)) / 2) 0;
}

.sortModalCloseIcon {
    width: var(--close-icon-size);
    height: var(--close-icon-size);
}

.sortModalList {
    display: flex;
    flex-direction: column;
    padding: var(--spacer-8) var(--labui-container-margin);
}

.sortModalItem {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: 12px;
    font: var(--font-button-16);
}

.sortModalItemCheck {
    width: 16px;
    height: 13px;
    opacity: 0;
    fill: var(--pecan);

    [data-selected] > & {
        opacity: 1;
    }
}

.emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-16);
    padding: var(--spacer-64);
    font: var(--font-p-18);
    border: 1px solid var(--gray-300);
}

.productList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: grid;
    gap: var(--labui-grid-gap);
    grid-template-columns: 1fr 1fr;
    container-type: inline-size;

    @container (min-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr;
    }

    > * {
        grid-column: span 1;

        @container (max-width: 500px) {
            grid-column: span 2;
        }
    }
}

// Approximate card sizes for the `sizes` HTML attribute.
// CSS custom props can't be used in `sizes`, so we approximate the sidebar chrome:
// sidebar gap (~40px) + container margins (~80px) = ~120px.
// Uses the 1-col width as an upper bound — slightly over-fetches at 2-col.
$chrome: 120px;

:export {
    gridCardSizes: string.unquote(
        "(min-width: #{$mobile}) calc(100vw - #{sidebar.$sidebar-width} - #{$chrome}), 100vw"
    );
}
